export default () => ({
  component: 'places-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
